module.exports = __webpack_public_path__ + "img/0001.d0289dc0.png";